<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="card mb-0">
  <div
    class="card-body p-0"
    [ngClass]="{
      h150: ((!items || (items && !items?.length)) && loadingItems) || (items?.length === 0 && !loadingItems),
    }"
  >
    <loading-spinner [isLoading]="loadingItems" [classesString]="'pt-88'"></loading-spinner>

    <div class="horizontal-scroll">
      <div class="table-wrap table_responsive" *ngIf="selectedColumns && selectedColumns.length > 1 && items">
        <table class="table m-0">
          <thead>
            <tr>
              <ng-container *ngFor="let column of selectedColumns; trackBy: trackByColumnName">
                <ng-template [ngIf]="column.sortable && column.propType !== 'checkbox'">
                  <th
                    class="text-nowrap {{ column.align?.length > 0 ? ' text-' + column.align : '' }} cursor-pointer {{
                      column.cssClass?.length > 0 ? column.cssClass : ''
                    }}"
                    (click)="sortBy(column.sortBy)"
                    style="padding-left: 5px"
                  >
                    {{ column.name | translate }}
                    <i
                      *ngIf="sortProp === column.sortBy"
                      class="fa"
                      [ngClass]="sortProp === column.sortBy && sortDir === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"
                    ></i>
                    <i
                      *ngIf="sortProp !== column.sortBy"
                      class="far"
                      [ngClass]="sortProp === column.sortBy && sortDir === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"
                    ></i>
                  </th>
                </ng-template>
                <ng-template
                  [ngIf]="
                    !column.sortable &&
                    column.propType !== 'btn' &&
                    column.propType !== 'btn-right' &&
                    column.propType !== 'checkbox'
                  "
                >
                  <th
                    class="text-nowrap {{ column.align && column.align.length > 0 ? ' text-' + column.align : '' }} {{
                      column.cssClass && column.cssClass.length > 0 ? column.cssClass : ''
                    }}"
                    style="padding-left: 5px"
                  >
                    {{ column.name | translate }}
                  </th>
                </ng-template>
                <ng-template
                  [ngIf]="!column.sortable && (column.propType === 'btn' || column.propType === 'btn-right')"
                >
                  <th class="pr-0 fixed-column-width">&nbsp;</th>
                </ng-template>
                <ng-template [ngIf]="column.propType === 'checkbox'">
                  <th>
                    <input type="checkbox" [ngModel]="isAllSelected" (ngModelChange)="onCheckboxChange(0, $event)" />
                  </th>
                </ng-template>
              </ng-container>
              <dropdown
                *ngIf="isColumnSettingVisible"
                [icon]="'far-cog'"
                [items]="columns | colSettings: selectedColumns"
                [isArrowHidden]="true"
                [autoClose]="true"
                (onResult)="onColumnSettingDropdownClick($event)"
              ></dropdown>
            </tr>
          </thead>
          <tbody *ngIf="items?.length === 0 && !loadingItems">
            <tr>
              <td [colSpan]="selectedColumns.length + 1" class="text-center p-5 border-bottom-0 no-hover">
                <div class="empty-list">
                  <i class="far fa-sad-tear" data-cy="empty"></i>
                  <div>
                    {{ 'no.record.found' | translate }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="items?.length > 0">
            <tr *ngFor="let item of items; trackBy: trackByIndex">
              <td
                class="{{ column.align && column.align.length > 0 ? ' text-' + column.align : '' }}  {{
                  column.cssClass && column.cssClass.length > 0 ? column.cssClass : ''
                }}"
                *ngFor="let column of selectedColumns; trackBy: trackByColumnName"
                [ngClass]="{
                  'p-0':
                    column.propType === 'btn' ||
                    column.propType === 'btn-gen' ||
                    column.propType === 'modal-eet-receipt' ||
                    column.propType === 'modal-address' ||
                    column.propType === 'btn-resend-eet-receipt',
                }"
                [ngStyle]="{ 'word-break': column.propType === 'product-link' ? 'break-all' : null }"
              >
                <span
                  *ngIf="column.propType === 'string' && item[column.property]?.length > 0"
                  title="{{ column.title | translate }}"
                  data-cy="first-column"
                >
                  {{ item[column.property] | translate }}
                </span>
                <span
                  *ngIf="column.propType === 'purchaseOrder-externalReference' && item[column.property]?.length > 0"
                  title="{{ column.title | translate }}"
                  data-cy="first-column-externalReference"
                >
                  <span *ngIf="item?.status?.id === 'draft'" class="text-yellow">{{
                    item[column.property] | translate
                  }}</span>
                  <span *ngIf="item?.status?.id !== 'draft'">{{ item[column.property] | translate }}</span>
                </span>
                <span *ngIf="column.propType === 'product-link' && item[column.property]?.length > 0">
                  <a [routerLink]="item.product?.id ? [column.route, item.product.id] : null">
                    {{ item[column.property] | translate }}
                  </a>
                </span>
                <span
                  *ngIf="
                    column.propType === 'string' &&
                    item[column.property] &&
                    !item[column.property].length &&
                    item[column.property].name
                  "
                  title="{{ column.title | translate }}"
                >
                  {{ item[column.property].name | translate }}
                </span>
                <span
                  *ngIf="column.propType === 'link' && item[column.property]?.id > 0"
                  title="{{ column.title | translate }}"
                >
                  <a [routerLink]="[column.route, item[column.property].id]">
                    {{
                      (item[column.property].name && item[column.property].name.length > 2
                        ? item[column.property].name
                        : item[column.property].email
                      ) | translate
                    }}
                  </a>
                </span>
                <span *ngIf="column.propType === 'integer'" title="{{ column.title | translate }}">
                  {{ item[column.property] }}
                </span>
                <span *ngIf="column.propType === 'number'" title="{{ column.title | translate }}">
                  {{
                    item[column.property] !== 0 && item[column.property] !== null && item[column.property] !== undefined
                      ? item[column.property].toFixed(2)
                      : item[column.property]
                  }}
                </span>
                <span *ngIf="column.propType === 'percent'" title="{{ column.title | translate }}">
                  {{
                    item[column.property] !== 0 && item[column.property] !== null && item[column.property] !== undefined
                      ? (item[column.property] | percent)
                      : (item[column.property] | percent)
                  }}
                </span>
                <span
                  *ngIf="column.propType === 'price-with-and-without-vat'"
                  title="{{ column.title | translate }}"
                  class="text-line-1"
                >
                  <div *ngIf="column.property === 'price'">{{ item['priceWithVat'] | formatPrice: item.currency }}</div>
                  <div *ngIf="column.property === 'price'">
                    {{ item['price'] | formatPrice: item.currency }} bez DPH
                  </div>
                  <div *ngIf="column.property === 'priceAll'">
                    {{ item['priceAllWithVat'] | formatPrice: item.currency }}
                  </div>
                  <div *ngIf="column.property === 'priceAll'">
                    {{ item['priceAll'] | formatPrice: item.currency }} bez DPH
                  </div>
                  <div *ngIf="column.property === 'purchasePrice'">
                    {{ item['purchasePriceWithVat'] | formatPrice: item.currency }}
                  </div>
                  <div *ngIf="column.property === 'purchasePrice'">
                    <small>{{ item['purchasePrice'] | formatPrice: item.currency }} bez DPH</small>
                  </div>
                  <div *ngIf="column.property === 'purchasePriceAll'">
                    {{ item['purchasePriceAllWithVat'] | formatPrice: item.currency }}
                  </div>
                  <div *ngIf="column.property === 'purchasePriceAll'">
                    <small>{{ item['purchasePriceAll'] | formatPrice: item.currency }} bez DPH</small>
                  </div>
                </span>
                <span *ngIf="column.propType === 'price'" title="{{ column.title | translate }}">
                  {{ item[column.property] | formatPrice: item.currency }}
                </span>
                <span *ngIf="column.propType === 'price-cents'" title="{{ column.title | translate }}">
                  {{
                    item[column.property] !== 0 ? (item[column.property] / 100).toFixed(2) : item[column.property]
                  }}&nbsp;{{
                    item.currency && item.currency.id
                      ? (item.currency.id | translate)
                      : (this.core.services.user.user.company.currency | formatCurrencyWithoutPrice)
                  }}
                </span>
                <span *ngIf="column.propType === 'date'" title="{{ column.title | translate }}">
                  {{ item[column.property] | fmtDate: 'dd.MM.yyyy' }}
                </span>
                <span *ngIf="column.propType === 'datetime'" title="{{ column.title | translate }}">
                  {{ item[column.property] | fmtDate: 'dd.MM.yyyy' }}
                  {{ item[column.property] | fmtDate: 'HH:mm' }}
                </span>
                <span *ngIf="column.propType === 'array'" title="{{ column.title | translate }}">
                  <span class="badge badge-light" *ngFor="let subItem of item[column.property]">
                    {{ subItem.name ? subItem.name : subItem ? subItem : ' ' }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'label'" title="{{ column.title | translate }}">
                  <span class="badge badge-light" *ngIf="item[column.property] && item[column.property].length > 0">
                    {{ item[column.property] }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'boolean'" title="{{ column.title | translate }}">
                  <span class="badge badge-success" *ngIf="item[column.property]">
                    {{ 'yes' | translate }}
                  </span>
                  <span
                    class="badge badge-danger"
                    *ngIf="!item[column.property]"
                    title="{{ column.title | translate }}"
                  >
                    {{ 'no' | translate }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'approved'" title="{{ column.title | translate }}">
                  <span class="badge badge-light" *ngIf="!item.approved && !item.rejected">
                    {{ 'waiting' | translate }}
                  </span>
                  <span class="badge badge-success" *ngIf="item.approved">
                    {{ 'inventory.approved' | translate }}
                  </span>
                  <span class="badge badge-danger" *ngIf="item.rejected">
                    {{ 'inventory.rejected' | translate }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'checkbox'">
                  <input
                    type="checkbox"
                    [ngModel]="item.isSelected"
                    (ngModelChange)="onCheckboxChange(item.id, $event)"
                  />
                </span>

                <div *ngIf="column.propType === 'img'" [photoGalleryGroup]="{ index: 1 }" class="images">
                  <div
                    *ngIf="item.product && item.product.id > 0"
                    [photoGallery]="getThumbUrl(item.product.mainImage, 'w2048wp')"
                    [photoGalleryCaption]="
                      item.product
                        ? item.product.name +
                          '<br>' +
                          (item.product.code ? ('base.listing.code' | translate) + item.product.code : '') +
                          '<br>' +
                          (item.product.ean ? ('base.listing.ean' | translate) + item.product.ean : '')
                        : ''
                    "
                  >
                    <div class="images-item">
                      <img
                        class="images-item-image"
                        [src]="getThumbUrl(item.product.mainImage)"
                        [alt]="item.product.name"
                      />
                    </div>
                  </div>
                </div>
                <span
                  *ngIf="column.propType === 'customer-name'"
                  title="{{ column.title | translate }}"
                  data-cy="customer-name"
                >
                  <ng-template [ngIf]="item['customer']">
                    <div>
                      {{
                        (item['customer'].firstName ? item['customer'].firstName : '') +
                          ' ' +
                          (item['customer'].lastName ? item['customer'].lastName : '')
                      }}
                    </div>
                    <div>{{ item['customer'].companyName ? item['customer'].companyName : '' }}</div>
                  </ng-template>
                  <ng-template [ngIf]="!item['customer'] && item['invoiceAddress']">
                    <div>
                      {{
                        (item['invoiceAddress'].firstName ? item['invoiceAddress'].firstName : '') +
                          ' ' +
                          (item['invoiceAddress'].lastName ? item['invoiceAddress'].lastName : '')
                      }}
                    </div>
                    <div>{{ item['invoiceAddress'].companyName ? item['invoiceAddress'].companyName : '' }}</div>
                  </ng-template>
                  <ng-template [ngIf]="!item['customer'] && !item['invoiceAddress'] && item['shippingAddress']">
                    <div>
                      {{
                        (item['shippingAddress'].firstName ? item['shippingAddress'].firstName : '') +
                          ' ' +
                          (item['shippingAddress'].lastName ? item['shippingAddress'].lastName : '')
                      }}
                    </div>
                    <div>{{ item['shippingAddress'].companyName ? item['shippingAddress'].companyName : '' }}</div>
                  </ng-template>
                </span>
                <span
                  *ngIf="column.propType === 'checkout-name' && item['checkout']"
                  title="{{ column.title | translate }}"
                >
                  {{ item['checkout'].name }}
                </span>
                <span
                  *ngIf="column.propType === 'carrier-name' && item['carrier']"
                  title="{{ column.title | translate }}"
                >
                  {{ item.carrier.name ? item.carrier.name : '' }}
                </span>
                <span
                  *ngIf="column.propType === 'relation-name' && item[column.property] && item[column.property].name"
                  title="{{ column.title | translate }}"
                >
                  <ng-container *ngIf="column.shouldBeTranslated; else elseBlock">{{
                    item[column.property].name | translate
                  }}</ng-container>
                  <ng-template #elseBlock>{{ item[column.property].name }}</ng-template>
                </span>
                <span
                  *ngIf="column.propType === 'item-id' && item[column.property] && item[column.property].id"
                  title="{{ column.title | translate }}"
                >
                  {{ item[column.property].id }}
                </span>
                <span
                  *ngIf="column.propType === 'process-status' && item['processStatus']"
                  title="{{ column.title | translate }}"
                  [ngClass]="'process-status-' + item.processStatus.id"
                >
                  <i
                    [ngClass]="
                      item.processStatus.id === 'recieved'
                        ? 'far fa-cart-arrow-down'
                        : item.processStatus.id === 'picking'
                          ? 'far fa-scanner'
                          : item.processStatus.id === 'packing'
                            ? 'far fa-box-full'
                            : item.processStatus.id === 'packed'
                              ? 'far fa-box-check'
                              : item.processStatus.id === 'dispatched'
                                ? 'far fa-shipping-fast'
                                : item.processStatus.id === 'delivered'
                                  ? 'far fa-check-circle'
                                  : item.processStatus.id === 'returned'
                                    ? 'far fa-shipping-timed'
                                    : item.processStatus.id === 'picking_error'
                                      ? 'far fa-exclamation-triangle'
                                      : item.processStatus.id === 'cancelled'
                                        ? 'far fa-ban'
                                        : ''
                    "
                  >
                  </i>
                  {{ item['processStatus'] ? item['processStatus'].name : '' }}
                </span>
                <span
                  *ngIf="column.propType === 'address-country' || column.propType === 'address-shipping'"
                  title="{{ column.title | translate }}"
                >
                  <span *ngIf="!!item[column.property]">
                    {{ item[column.property].country }}
                  </span>
                </span>

                <span *ngIf="column.propType === 'reservation-number'" class="text-center">
                  <span>
                    {{ item['reservationNumber'] }}
                  </span>
                </span>
                <div *ngIf="column.propType === 'tags'" class="container-tags">
                  <ng-container *ngFor="let tag of item['tags']">
                    <span
                      class="tag-span"
                      [ngStyle]="{ 'background-color': tag.color ? tag.color : '#0058FF', color: 'white' }"
                    >
                      {{ tag.name }}
                    </span>
                  </ng-container>
                </div>

                <span *ngIf="column.propType === 'array-vertical'" class="text-center">
                  <div
                    *ngIf="item[column.property] && item[column.property].length > 0"
                    class="badge bg-blue unavail-badge"
                    style="position: absolute"
                  >
                    <i class="far fa-list"></i>
                    <div class="unavail-list-right">
                      <div *ngFor="let it of item[column.property]">{{ it | translate }}</div>
                    </div>
                  </div>
                  &nbsp;
                </span>
                <span *ngIf="column.propType === 'operation-type'" class="text-center">
                  <i
                    *ngIf="item[column.property].id === 'in'"
                    class="in-badge fas fa-plus-square"
                    title="{{ item[column.property].name | translate }}"
                  ></i>
                  <i
                    *ngIf="item[column.property].id === 'out'"
                    class="out-badge fas fa-minus-square"
                    title="{{ item[column.property].name | translate }}"
                  ></i>
                  <i
                    *ngIf="item[column.property].id === 'transfer'"
                    class="transfer-badge fas fa-exchange-alt"
                    title="{{ item[column.property].name | translate }}"
                  ></i>
                  <i
                    *ngIf="item[column.property].id === 'reservation'"
                    class="reservation-badge fas fa-clock"
                    title="{{ item[column.property].name | translate }}"
                  ></i>
                </span>
                <span *ngIf="column.propType === 'depot-from-to'">
                  <span *ngIf="item.depotFrom && item.depotFrom.id > 0">
                    {{ (item.depotFrom.name && item.depotFrom.name.length > 2 ? item.depotFrom.name : '') | translate }}
                  </span>
                  <span *ngIf="item.depotFrom && item.depotFrom.id > 0 && item.depotTo && item.depotTo.id > 0">/</span>
                  <span *ngIf="item.depotTo && item.depotTo.id > 0">
                    {{ (item.depotTo.name && item.depotTo.name.length > 2 ? item.depotTo.name : '') | translate }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'types-with-values'">
                  <span *ngIf="item.discountType">
                    {{ (item.discountType && item.discountType.length > 0 ? item.discountType : '') | translate }}
                  </span>
                  <span *ngIf="item.discountPercent">
                    {{ item.discountPercent + '%' }}
                  </span>
                  <span *ngIf="item.discountValue">
                    {{ item.discountValue | formatPrice: item.currency }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'used-maxUse'">
                  <span>
                    {{ item.used ? item.used : 0 }}
                  </span>
                  <span>/</span>
                  <span *ngIf="item.maxUse">
                    {{ item.maxUse }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'batch-and-expiration' && item['move']">
                  <span *ngIf="item['move'].expirationDate"
                    >customer
                    {{ item['move'].expirationDate | fmtDate: 'dd.MM.yyyy' }}
                  </span>
                  <span *ngIf="item['move'].expirationDate && item['move'].batch">/</span>
                  <span *ngIf="item['move'].batch">
                    {{ item['move'].batch }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'fullName'">
                  <span *ngIf="item.firstName && item.firstName.length > 0">
                    {{ item.firstName }}
                  </span>
                  <span *ngIf="item.lastName && item.lastName.length > 0">
                    {{ item.lastName }}
                  </span>
                </span>
                <span *ngIf="column.propType === 'notes'" class="d-flex flex-column">
                  <span *ngIf="item.note && item.note?.length > 0">
                    <span data-toggle="tooltip" title="{{ 'note' | translate }}:  {{ item.note }}">{{
                      item.note.length > 10 ? (item.note | slice: 0 : 10) + '...' : item.note
                    }}</span>
                    <div class="tooltip bs-tooltip-top" role="tooltip">
                      <div class="arrow"></div>
                    </div>
                  </span>
                  <span *ngIf="item.private && item.private?.length > 0">
                    <span data-toggle="tooltip" title="{{ 'note.private' | translate }}:  {{ item.privateNote }}">{{
                      item.privateNote.length > 10 ? (item.privateNote | slice: 0 : 10) + '...' : item.privateNote
                    }}</span>
                    <div class="tooltip bs-tooltip-top" role="tooltip">
                      <div class="arrow"></div>
                    </div>
                  </span>
                </span>
                <span *ngIf="column.propType === 'createdByName'" class="d-flex flex-column">
                  <span *ngIf="!item?.createdBy">AUTO</span>
                  <span *ngIf="item?.createdBy?.name">{{ item.createdBy.name }}</span>
                </span>
                <span *ngIf="column.propType === 'custom-relation'" class="d-flex flex-column">
                  <span *ngIf="!column.pipe">{{ item | customCol: column.property }}</span>
                  <span *ngIf="column.pipe === 'fmtDate'">{{ item | customCol: column.property | fmtDate }}</span>
                </span>
                <span *ngIf="column.propType === 'purchaseOrderItem-quantity'" class="d-flex flex-column">
                  {{ (item.quantity - item.quantityIn).toFixed(2) }}
                </span>
                <span *ngIf="column.propType === 'purchaseOrder-status'" class="d-flex flex-column">
                  <span *ngIf="item?.status?.id === 'draft'" class="text-yellow">{{
                    'purchaseOrderStatus.' + item.status.id | translate
                  }}</span>
                  <span *ngIf="item?.status?.id !== 'draft'">{{
                    'purchaseOrderStatus.' + item.status.id | translate
                  }}</span>
                </span>
                <span *ngIf="column.propType === 'purchaseOrder-link'" class="d-flex flex-column">
                  <a [routerLink]="['/purchase-order', item.purchaseOrder.id]">{{ item.purchaseOrder.number }}</a>
                </span>
                <span *ngIf="column.propType === 'btn' && !column.action && column.route">
                  <a
                    [routerLink]="[column.route, item.id]"
                    class="btn-{{ column.btnStyle }} float-right ml-2"
                    [title]="column.name | translate"
                    data-cy="download-report"
                  >
                    <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} mr-2"></i>
                    {{ column.name | translate }}
                  </a>
                </span>
                <span *ngIf="column.propType === 'btn' && column.action && !column.route">
                  <a
                    class="btn-{{ column.btnStyle }} float-right ml-2"
                    [title]="column.name | translate"
                    (click)="onAction(column.action, item)"
                    data-cy="dowload-report"
                  >
                    <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} mr-2"></i>
                    {{ column.name | translate }}
                  </a>
                </span>
                <span *ngIf="column.propType === 'btn-right' && !column.action && column.route">
                  <a
                    [routerLink]="[column.route, item.id]"
                    [title]="column.name | translate"
                    class="btn-{{ column.btnStyle }} float-right ml-2 cursor-pointer"
                    data-cy="open-row"
                    [id]="item.id"
                    (click)="saveSelectedItem(item.id)"
                  >
                    {{ column.name | translate }}
                    <i class="far fa-{{ column.icon ? column.icon : 'file-o' }} ml-2"></i>
                  </a>
                </span>

                <span *ngIf="column.propType === 'btn-right' && column.action && !column.route">
                  <a
                    class="btn-{{ column.btnStyle }} float-right ml-2 cursor-pointer"
                    (click)="onAction(column.action, item)"
                    [title]="column.name | translate"
                  >
                    <i
                      *ngIf="column.icon === 'layer-plus'"
                      class="far fa-{{ column.icon ? column.icon : 'chevron-right' }} mr-2"
                    ></i>
                    {{ column.name | translate }}
                    <i
                      *ngIf="column.icon !== 'layer-plus'"
                      class="far fa-{{ column.icon ? column.icon : 'chevron-right' }} ml-2"
                    ></i>
                  </a>
                </span>
                <span
                  *ngIf="
                    column.propType === 'btn-stockup' &&
                    column.action &&
                    !column.route &&
                    item.status?.id !== 'draft' &&
                    item.status?.id !== 'stocked' &&
                    item.status?.id !== 'cancelled'
                  "
                >
                  <a
                    class="btn-{{ column.btnStyle }} float-right ml-2 cursor-pointer"
                    (click)="onAction(column.action, item)"
                    [title]="column.name | translate"
                  >
                    <i class="far fa-{{ column.icon ? column.icon : 'chevron-right' }} mr-2"></i>
                    {{ column.name | translate }}
                  </a>
                </span>
                <span *ngIf="column.propType === 'btn-gen' && column.action && !column.route">
                  <a
                    class="btn-second btn-sm float-right"
                    *ngIf="!item.generated"
                    [title]="'reports.generating' | translate"
                    disabled
                  >
                    <i class="fa fa-spinner fa-spin mr-2"></i>
                    {{ 'reports.generating' | translate }}
                  </a>
                  <a
                    class="btn-{{ column.btnStyle }} float-right ml-2"
                    (click)="onAction(column.action, item)"
                    [title]="column.name | translate"
                    *ngIf="item.generated"
                  >
                    <i
                      class="far mr-2"
                      [ngClass]="{
                        'fa-eye': !item.format,
                        'fa-file-pdf': item.format === 'pdf',
                        'fa-file-excel': item.format === 'excel',
                      }"
                    ></i>
                    {{ column.name | translate }}
                  </a>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <app-pagination-btn
          *ngIf="!!((!this.currentPage || this.currentPage <= this.endPage) && this.totalItems > this.items?.length)"
          (switchPage)="paginate($event)"
          [currentPage]="currentPage"
          [endPage]="endPage"
          [sortProp]="sortProp"
          [sortDir]="sortDir"
          [loadingPage]="loadingItems || loadingNextItems"
        >
        </app-pagination-btn>
      </div>
    </div>
  </div>
</div>
